<template>
    <div class="mask" v-show="isMask">
        <div class="mask_in">
            <van-icon name="cross" class="closeIcon" @click="closePostFrom" />
            <div class="infrom">
                <ul>
                    <li v-for="(item,index) in postInformList" :key="index" @click="handleSelectInform(item.content)">{{item.content}}</li>
                    <li @click="closePostFrom">取消</li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:'postInform',
    props:{
        isMask:''
    },
    data () {
        return {
            postInformList:[{
                    id:"001",
                    content:'惡意廣告'
                },
                {
                    id:"002",
                    content:'內容違法'
                },
                {
                    id:"003",
                    content:'色情暴力'
                },
                {
                    id:"004",
                    content:'造謠造假'
                },
                {
                    id:"005",
                    content:'其他'
                }]
        }
    },
    methods: {
        closePostFrom() {
            this.$emit('closePostFrom')
            // this.isMask = false
        },
        handleSelectInform(content) {
            this.$emit('handleSelectInform',content);
        }
    },
}
</script>

<style lang="stylus" scoped>
@media all and (orientation : landscape)
    .van-icon-cross
        position absolute
        right -1.1rem
        color #fff
        font-size .5rem
        top 0
        cursor pointer
    .mask
        height: 100%;
        width: 100%;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 999999999999;
        background: #000;
        background: rgba(26, 26, 26, .65);
        .mask_in
            position absolute
            width: 6rem;
            height: 5rem;
            left: 50%;
            top: 50%;
            margin-left: -3rem;
            margin-top: -2.5rem;
            .infrom
                position: fixed;
                width: 6rem;
                height: 5rem;
                padding: 0 .12rem;
                overflow: auto;
                border-radius: 2px;
                background: #fff;
                .closeIcon
                    position absolute
                    right 10px
                    top 10px
                ul
                    width 100%
                    li
                        width 100%
                        padding .25rem 0
                        text-align center
                        color #000
                        font-size 0.305rem
                        border-bottom:1px solid #f6f6f6
                        cursor pointer
                        &:last-child
                            border-bottom none
@media all and (orientation : portrait)
    .van-icon-cross
        position absolute
        right -.8rem
        color #fff
        font-size .5rem
        top 0
    .mask
        position: fixed;
        top: 0;
        left: 0;
        z-index: 20;
        height: 100%;
        width: 100%;
        background: #000;
        background: rgba(26, 26, 26, .65);
        .mask_in
            position absolute
            width: 5rem;
            height: 5rem;
            left: 50%;
            top: 50%;
            margin-left: -2.5rem;
            margin-top: -2.5rem;
            .infrom
                position: fixed;
                width: 5rem;
                height: 5rem;
                overflow: auto;
                border-radius: 2px;
                background: #fff;
                .closeIcon
                    position absolute
                    right 10px
                    top 10px
                ul
                    width 100%
                    li
                        width 100%
                        padding .25rem 0
                        text-align center
                        color #000
                        font-size 0.305rem
                        border-bottom:1px solid #f6f6f6
                        &:last-child
                            border-bottom none

</style>